import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleKiloleterMasterList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const kiloleterMasterListAsync=createAsyncThunk(
   "companyMaster/list",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await handleKiloleterMasterList();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const companyMasterListSlice = createSlice({
   name: "companyMaster",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(kiloleterMasterListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(kiloleterMasterListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(kiloleterMasterListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default companyMasterListSlice.reducer;